import {SignIn} from './SignIn';
import {Filter} from './Filter';
import {SignUp} from './SignUp';
import {MyWallet} from './MyWallet';
import {Checkout} from './Checkout';
import {MyCoupons} from './MyCoupons';
import {MyWishlist} from './MyWishlist';
import {Onboarding} from './Onboarding';
import {NewPassword} from './NewPassword';
import {ProfileEdit} from './ProfileEdit';
import {AddANewCard} from './AddANewCard';
import {LeaveAReview} from './LeaveAReview';
import {CategoryList} from './CategoryList';
import {CategoryGrid} from './CategoryGrid';
import {CourseDetails} from './CourseDetails';
import {PaymentFailed} from './PaymentFailed';
import {PrivacyPolicy} from './PrivacyPolicy';
import {PaymentSuccess} from './PaymentSuccess';
import {ForgotPassword} from './ForgotPassword';
import {HelpAndSupport} from './HelpAndSupport';
import {CourseCompleted} from './CourseCompleted';
import {ConfirmationCode} from './ConfirmationCode';
import {ChoosePaymentMethod} from './ChoosePaymentMethod';
import {SignUpAccountCreated} from './SignUpAccountCreated';
import {VerifyYourPhoneNumber} from './VerifyYourPhoneNumber';
import {ForgotPasswordSentEmail} from './ForgotPasswordSentEmail';
import {CourseCompletedCertificate} from './CourseCompletedCertificate';

// Tabs
import {Home} from './tabs/Home';
import {Search} from './tabs/Search';
import {Profile} from './tabs/Profile';
import {MyCourses} from './tabs/MyCourses';

export const screens = {
  Home,
  SignIn,
  Search,
  SignUp,
  Filter,
  Profile,
  MyWallet,
  Checkout,
  MyCoupons,
  MyCourses,
  MyWishlist,
  Onboarding,
  AddANewCard,
  ProfileEdit,
  NewPassword,
  CategoryGrid,
  LeaveAReview,
  CategoryList,
  CourseDetails,
  PaymentFailed,
  PrivacyPolicy,
  PaymentSuccess,
  ForgotPassword,
  HelpAndSupport,
  CourseCompleted,
  ConfirmationCode,
  ChoosePaymentMethod,
  SignUpAccountCreated,
  VerifyYourPhoneNumber,
  ForgotPasswordSentEmail,
  CourseCompletedCertificate,
};
